import { COLORS } from "shared/consts"
import { toEm, toRem } from "shared/helpers"
import styled from "styled-components"

export const DiaryHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(12)};
  padding: ${toRem(16)} 0;
`
type DiaryHeadRowProps = {
  $overflow?: string;
}
export const DiaryHeadRow = styled.div<DiaryHeadRowProps>`
  display: flex;
  gap: ${toRem(12)};
  overflow: ${props => props.$overflow || 'initial'};
  scrollbar-width: none;

  .popover__root {
    width: max-content;
    max-width: 100%;
  }

  .tagitem__label {
    &:has(svg) {
      display: flex;
      justify-content:center;align-items: center;
    }
  }

  @media (width < ${toRem(768)}){
    gap: ${toRem(8)};
  }
`

export const DateWrapper = styled.div`
  --max-width: ${toRem(220)};
  max-width: var(--max-width);
  flex: 0 1 var(--max-width);

  .input {
    min-width: 0;
  }
  .popover__root {
    width: 100%;
  }

  @media (width < ${toEm(1200)}){
    --max-width: ${toRem(180)};
  }

  @media (width >= ${toRem(768)}){
    .dropdown,
    .popover__root {
      width: 100%;
      max-width: var(--max-width);
    }
  }

  @media (width < ${toRem(768)}){
    --max-width: calc(50% - ${toRem(4)});
    .dropdown {
      width: 100%;
    }
  }
`

export const DiaryFiltersDrawerWrapper = styled.div`
  background-color: ${COLORS.BG.PAGE_FILLED};
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (width >= ${toRem(400)}){
    width: ${toRem(400)};
  }
  @media (width < ${toRem(400)}){
    width: 100vw;
  }
`

export const DiaryFiltersBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
  padding: ${toRem(16)};
  flex: 1 1 calc(100% - ${toRem(172)});
  max-height: calc(100% - ${toRem(172)});
  overflow: hidden auto;

  @media (width < ${toRem(768)}){
    flex: 1 1 calc(100% - ${toRem(153)});
    max-height: calc(100% - ${toRem(153)});
  }
`

export const DiaryFiltersFooter = styled.div`
  padding: ${toRem(16)};
`

export const DiaryFiltersItem = styled.div`
  background-color: ${COLORS.BG.ELEVATED.M};
  padding: ${toRem(16)};
  border-radius: ${toRem(16)};
  box-shadow: 0px 2px 4px 0px ${COLORS.NEUTRAL.CONTAINER_SOFT}, 0px 0px 8px 0px ${COLORS.NEUTRAL.CONTAINER_MUTED};
  @media (width >= ${toRem(768)}){
    min-width: ${toRem(312)};
  }

  .input.input--size-m.input--textarea {
    margin-top: ${toRem(22)};
  }

  textarea {
    border-radius: ${toRem(8)};
    border: ${toRem(2)} solid ${COLORS.BORDER.MUTED};
    resize: none;
    min-height: ${toRem(80)};
    padding: ${toRem(8)} ${toRem(12)};
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
  }
`

export const DiaryFiltersItemTitle = styled.h3`
  font-weight: 700;
  font-size: ${toRem(16)};
  line-height: ${20 / 16};
  color: ${COLORS.FG.DEFAULT};
  display: flex;
  justify-content: space-between;
  gap: ${toRem(12)};
  &:not(:last-child) {
    margin-bottom: ${toRem(16)};
  }

  button {
    color: ${COLORS.ACCENT.DEFAULT};
    transition: color 0.3s ease 0s;

    @media (any-hover: hover){
      &:hover{
        color: ${COLORS.ACCENT.HOVER};
      }
    }
  }
`

export const DiaryFiltersRangeItemBody = styled.div`
  display: flex;
  gap: ${toRem(12)};

  .input {
    min-width: 0;
  }
`

export const DiaryFiltersTextareaLabel = styled.div`
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
  color: ${COLORS.FG.SOFT};
  &:not(:last-child) {margin-bottom: ${toRem(4)};}
`

export const DiaryFiltersRangeItemFooter = styled.div`
  padding-top: ${toRem(12)};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${toRem(16)};
`

export const DiaryFiltersAuthorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};
  min-width: ${toRem(208)};
  max-height: calc(100dvh - ${toRem(355)});
  overflow: auto;
  min-height: ${toRem(200)};
`;